import React, { Dispatch, ReactNode, SetStateAction } from 'react';
import { Drawer } from '@mui/material';
import { DrawerOpenSides } from '../../../Interfaces/componentTypes';

interface IProps {
    open: boolean,
    onClose: Dispatch<SetStateAction<boolean>>,
    children: ReactNode,
    openSide?: DrawerOpenSides
}

const CustomDrawer: React.FC<IProps> = (props) => {
    const { children, open, openSide = DrawerOpenSides.Right, onClose } = props;

    return (
        <>
            <Drawer
                open={open}
                onClose={onClose}
                anchor={`${openSide}`}
                variant='temporary'
                slotProps={{
                    backdrop: {
                      style: {
                        backgroundColor: 'rgba(0, 0, 0, 0.4)', 
                        backdropFilter: 'blur(5px)', 
                      },
                    },
                  }}
            >
                {children}
            </Drawer>
        </>
    )
}

export default CustomDrawer
